import { useEffect } from 'react';
import { useState } from './stateref';
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}

const handleUserStorage = (e) => {
  const user = JSON.parse(localStorage.getItem('user'))
  //TODO: whitelist only webflow
  // if (!['http://admin2.zennyadev.com:3000', 'https://admin2.zennya.com', 'http://dev.admin2.zennya.com'].includes(e.origin))
  //   return;
  if (user?.token) {
    console.log('sending cheese')
    e?.source?.postMessage(user?.token + "|" + user?.user?.id || user?.client?.id, e.origin)
  }
}
function useListenForAccess() {
  useEffect(
    () => {
      window.addEventListener('userstorage', handleUserStorage)
      return () => window.removeEventListener('userstorage', handleUserStorage)
    }, []
  );

  return null

}

export { useWindowSize, useListenForAccess }